import ValidateModule from "./ValidateModule";

import type { IEventChannel } from "../model/Models";
import type AjaxRequestBroker from "../AjaxRequestBroker";
import type {ApiOpts} from "@esWebAPI/es/model/Models";
import type CacheModule from "./CacheModule";

const es = global.es;

/**
 * @class DistanceModule
 */
export default class DistanceModule {
    private eventChannel: IEventChannel;
    private rqBroker: AjaxRequestBroker;
    private resourceName: string;
    private cache: CacheModule;

    constructor(eventChannel: IEventChannel, rqBroker: AjaxRequestBroker, resourceName: string, cache: CacheModule) {
        this.eventChannel = eventChannel;
        this.rqBroker = rqBroker;
        this.resourceName = resourceName;
        this.cache = cache;

        this.getDriveDistance = this.getDriveDistance.bind(this);
    }

    /**
     * Get total drive time and distance for the specified request
     * @param {{points: []}} request
     * @param opts
     * @return {Promise<{distance: number, time: number}>}
     */
    getDriveDistance(request, opts?: ApiOpts) {
        if (!ValidateModule.checkMandatoryArg(request.points) || request.points.length < 2) {
            return es.util.deferred.rejected();
        }

        return this.rqBroker.doPost({
            url: es.api.getURL(this.resourceName) + '/drivetime',
            data: request,
            opts: opts
        });
    }
}
